import { ERROR_CODES } from '@/shared/constants/errors.js'
import AuthController from '../domain/controller.js'
import { EVENTS } from '../utils/constants.js'
import publishUserData from './publishUserData.js'
import saveUserInLocalData from './saveUserInLocalData.js'
import handleTwoFactorAuth from './handleTwoFactorAuth.js'
import InactivityTracker from '../utils/inactivityTracker.js'

async function makeLogin(context, payload) {
  console.log('🚀 ~ makeLogin ~ payload:', payload)
  const { events, networkRepo, localRepo, sendBugAlert } = context

  events.dispatch(EVENTS.APPLICATION_IS_WORKING)
  events.dispatch(EVENTS.LOGIN_STARTED)

  let user = null

  try {
    user = await AuthController.login(payload, networkRepo, localRepo)
    console.log('🚀 ~ makeLogin ~ user:', user)
  } catch (error) {
    console.log('🚀 ~ makeLogin ~ error:', error)

    let title = 'Login error'
    let body =
      'We are unable to log you in. Please try again later or contact us.'

    switch (error?.code) {
      case ERROR_CODES.INVALID_CREDENTIALS:
        title = 'Incorrect credentials'
        body = 'The email or password you entered is incorrect.'
        break

      case ERROR_CODES.NOT_FOUND:
        title = 'User not found'
        body = 'No account is associated with this email.'
        break

      case ERROR_CODES.SERVICE_UNAVAILABLE:
        title = 'Service temporarily unavailable'
        body =
          'Our servers are currently unreachable. Please try again in a few moments.'
        break

      case ERROR_CODES.SERVER_ERROR:
      default:
        title = 'Internal server error'
        body = 'An unexpected error occurred. Our teams have been notified.'
        sendBugAlert(error)
        break
    }

    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title,
      body,
      type: 'error',
    })
  }

  events.dispatch(EVENTS.LOGIN_FINISHED)
  events.dispatch(EVENTS.APPLICATION_WORK_FINISHED)

  if (!user) return { success: false, user }

  // 2FA - Double authentification avant la connexion effective
  const twoFactorRes = await handleTwoFactorAuth(context, user)
  if (!twoFactorRes || !twoFactorRes.success) {
    console.warn('2FA annulé ou échoué.')
    return { success: false, user: null, reason: '2FA_FAILED' }
  }

  events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: `Login successful ${user.firstName}`,
    body: 'Welcome',
  })

  // Réinitialiser le compteur d'inactivité au moment de la connexion
  InactivityTracker.reset()

  await saveUserInLocalData(context)
  await publishUserData(context)
  context.events.dispatch(EVENTS.USER_CONNECTED)
  return { success: true, user }
}

export default makeLogin
